<script>
  import IntersectionObserver from "svelte-intersection-observer";
  import Barchart from "./Barchart.svelte";
  import Emoji from "@helpers/Emoji.svelte";

  let element;
  export let intersecting = false;

  import { guessIsCorrect } from "@stores/userData.js";
</script>

<IntersectionObserver {element} bind:intersecting>
  <section bind:this={element} id="other-cities">
    <div class="prose">
      <h1 class="section-title">
        The answer? <span
          class:unanswered={typeof $guessIsCorrect !== "boolean"}
          class="answer accent-text emoji-follows"
          data-emoji="💸"
          >$5.1 billion!<Emoji emoji="money" styles="right: -25%" /></span
        >
      </h1>
      <p class="body-text">
        {$guessIsCorrect != null
          ? $guessIsCorrect
            ? "You got it!"
            : "You were close!"
          : ""}
        Houston has the <strong>5th largest budget</strong> in the United States,
        in terms of its sheer size.
      </p>
      <p class="body-text">
        Dividing among all Houstonians, that comes out to a spending equivalent
        to
        <strong>$2,476 per Houstonian.</strong>
        This data is compiled by
        <a
          href="https://ballotpedia.org/Analysis_of_spending_in_America%27s_largest_cities"
          target="_blank"
          rel="noopener noreferrer">Ballotpedia</a
        >.
      </p>
    </div>
    <Barchart />
  </section>
</IntersectionObserver>

<style>
  section {
    text-align: left;
    padding: 5rem 1rem;
    /* margin: 0 auto 5rem auto; */
    display: flex;
    flex-direction: column;
    justify-content: center;
    place-items: center;
    /* min-height: 100vh; */
    /* background: rgb(245, 166, 35); */
    border: 1px solid rgba(var(--text-color-rgb), 0.25);
  }

  .emoji-follows::before {
    top: -1rem;
    right: -5rem;
  }

  .answer {
    transition: filter 1000ms ease 500ms;
  }
  .unanswered {
    filter: blur(12px);
  }

  .unanswered:hover {
    transition: filter 400ms ease;
    filter: none;
  }
</style>
